module.exports = __webpack_public_path__ + "img/webstreamsite.5f2cfc6f.png";